import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginForm from '../../components/Auth/LoginForm';
import { Card, CardBody, CardHeader } from '@heroui/react';
import { KeyIcon } from '@heroicons/react/24/outline';
import './LoginPage.css';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to intended page if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  // Show loading or redirect if already authenticated
  if (isAuthenticated) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <span className="ml-2">Redirecting...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <Card className="login-card">
          <CardHeader className="login-header">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-indigo-200 rounded-full flex items-center justify-center shadow-md border border-blue-300">
                <KeyIcon className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">PIVOT-PT</h1>
                <p className="text-sm text-gray-600">Physical Therapy Management System</p>
              </div>
            </div>
          </CardHeader>
          
          <CardBody className="login-body">
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                Welcome Back
              </h2>
              <p className="text-gray-600">
                Please sign in to your account to continue
              </p>
            </div>
            
            <LoginForm />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage;
